import React from 'react';
import { CalendarClockIcon, HourglassIcon, PaletteIcon, PackageOpenIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const points = [[CalendarClockIcon, 'Du suchst sonntagabends noch nach einer Idee für die Kunststunde am Montag.'], [PaletteIcon, 'Du unterrichtest Kunst fachfremd und fühlst dich im Fach unsicher.'], [PackageOpenIcon, 'Dein Projekt scheitert daran, dass das nötige Material fehlt.'], [HourglassIcon, 'Die halbe Klasse ist nach zehn Minuten fertig und du weißt nicht, wohin damit.']] as const;
export function PainPointsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-117" data-mp="3fer7gd9np8fq">
      <Reveal className="mx-auto max-w-4xl text-center" data-id="element-118" data-mp="3ag68sia1ywte">
        <h2 className="text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-119" data-mp="3aisfygt17ab3">
          <span className="text-brand-orange" aria-hidden="true" data-id="element-120" data-mp="3ogh0ton3mhg5">
            ✧
          </span>{' '}
          Erkennst du dich in diesen Situationen wieder?
        </h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-121" data-mp="svtabhw93stn">
          {points.map(([PointIcon, text]) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-line bg-brand-main p-6 text-left shadow-sm" data-id="element-122" data-mp="wx4tp5oj7hte">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange" data-id="element-123" data-mp="16vkk16fqin1u">
                <PointIcon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="1btds650llr4r" />
              </span>
              <span className="text-sm font-semibold leading-snug" data-id="element-125" data-mp="1fto6q62ghpv8">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-script text-2xl italic text-brand-orange" data-id="element-126" data-mp="1koa8rimne62n">
          Und du verdienst so viel mehr als das.
        </p>
      </Reveal>
    </section>;
}